import React from 'react';
import PropTypes from 'prop-types';
import { Button, Grid, Container } from '@material-ui/core';

import Icons from 'consts/icons';
import { STATUS_COLORS } from 'consts/mapConfig';
import { useSelector } from 'react-redux';
import { parseDate } from 'utils/main';
import { tableStyles } from 'components/common/components/tablev2/CustomizedTableUseStyles';
import ButtonsUseStyles from 'consts/styles/Buttons';
import Tooltip from '@material-ui/core/Tooltip';
import { formStyles } from 'consts/styles/Form';
import { userStyles } from 'consts/styles/User';

const DisplayMissionHistoryDetails = props => {
  const { selectedMission, handleZoom } = props;

  const subtitles = useSelector(state => state.language).missionsApprovals;
  const timezone = useSelector(state => state.timezone);

  const [minMaxHeight, setMinMaxHeight] = React.useState([null, null]);

  const tableClasses = tableStyles();
  const classesUser = userStyles();
  const classesButtons = ButtonsUseStyles();
  const formClasses = formStyles();

  const getMinMaxHeight = legs => {
    if (!legs.features.length) return;
    let [min, max] = legs.features[0].properties?.aglMinMaxM;
    for (let i = 1; i < legs.features.length; i += 1) {
      if (legs.features[i].properties?.aglMinMaxM[0] < min)
        min = legs.features[i].properties?.aglMinMaxM[0];
      if (legs.features[i].properties?.aglMinMaxM[1] > max)
        max = legs.features[i].properties?.aglMinMaxM[1];
    }

    return [min, max];
  };

  React.useEffect(() => {
    setMinMaxHeight(getMinMaxHeight(selectedMission.legs));
  }, []);

  return (
    <Grid container className={`${classesUser.User}__settings`}>
      <div className={`${classesUser.User}__settings__content__spacer`} />
      <div
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--direction ${formClasses.Form}--flex--flex-end`}
      >
        <Container>
          <Grid
            container
            spacing={1}
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
          >
            <Grid item xs={12}>
              <div className={`${formClasses.Form}__label`}>
                {`${subtitles.uid_}: `}
                <span
                  className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
                >
                  {selectedMission.uid}
                </span>
              </div>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid
            container
            spacing={1}
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
          >
            <Grid item xs={9}>
              <div className={`${formClasses.Form}__label`}>
                {subtitles.name_}
              </div>
              <div className={`${formClasses.Form}__text-field`}>
                {selectedMission.uid.substring(0, 8)}
              </div>
            </Grid>
            <Grid item xs={3} align="right">
              <Tooltip title={subtitles.zoom_} placement="right">
                <Button
                  type="button"
                  fullWidth
                  onClick={() => handleZoom()}
                  className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsCircle}--mid ${classesButtons.ButtonsCircle}`}
                >
                  <Icons.Zoom.ZoomInOnMap />
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid
            container
            spacing={1}
            className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--height--dashboard-min-height`}
          >
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.status_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field ${tableClasses.CustomizedTable}__container__table__body__row__cell--status`}
                style={{
                  color: STATUS_COLORS.white,
                  backgroundColor:
                    STATUS_COLORS[selectedMission.dtm_status]?.stroke,
                  borderColor:
                    STATUS_COLORS[selectedMission.dtm_status]?.stroke,
                }}
              >
                {selectedMission.dtm_status}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.statusUtm_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field ${tableClasses.CustomizedTable}__container__table__body__row__cell--status`}
                style={{
                  color: STATUS_COLORS.white,
                  backgroundColor:
                    STATUS_COLORS[selectedMission.status]?.stroke,
                  borderColor: STATUS_COLORS[selectedMission.status]?.stroke,
                }}
              >
                {selectedMission.status}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.start_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {parseDate(selectedMission.start, timezone)}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.stop_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {parseDate(selectedMission.stop, timezone)}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.type_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedMission.typ}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.modified_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {parseDate(selectedMission.modified, timezone) || '-'}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.minHeight_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {minMaxHeight[0] !== null ? `${minMaxHeight[0]} m` : '-'}
              </span>
            </Grid>
            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.maxHeight_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {`${minMaxHeight[1]} m` || '-'}
              </span>
            </Grid>

            <Grid item xs={6}>
              <span className={`${formClasses.Form}__label`}>
                {subtitles.desc_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedMission.description || '-'}
              </span>
            </Grid>
            <Grid
              item
              xs={6}
              className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
            >
              <span className={`${formClasses.Form}__label`}>
                {subtitles.numberOfLegs_}
              </span>
              <br />
              <span
                className={`${formClasses.Form}__text-field--small-font ${formClasses.Form}__text-field`}
              >
                {selectedMission.legs.features.length}
              </span>
            </Grid>
          </Grid>
        </Container>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div
                className={`${classesUser.User}__settings__content__spacer`}
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </Grid>
  );
};

export default DisplayMissionHistoryDetails;

DisplayMissionHistoryDetails.propTypes = {
  selectedMission: PropTypes.object.isRequired,

  handleZoom: PropTypes.func.isRequired,
};
